module.exports = __webpack_public_path__ + "db093b6a7b9dbbbe604e6e30d7a201f9.svg";